
(function () {
  const storageKey = "mfpa_utm";
  const fields = [
    "utm_source",
    "utm_campaign",
    "utm_content"
  ];

  try {
    const params = new URLSearchParams(window.location.search);
    const utm = {};

    fields.forEach(function (field) {
      const value = params.get(field);

      if (value) {
        utm[field] = value;
      }
    });

    // Save the latest campaign when UTM parameters are present.
    // Otherwise, preserve the previously captured campaign.
    if (Object.keys(utm).length > 0) {
      sessionStorage.setItem(storageKey, JSON.stringify(utm));
    }
  } catch (error) {
    // Tracking should never interrupt the website.
  }
})();
